type IconType = 'checked' | 'unchecked';

export type PackageType = 'free' | 'premium' | 'default';

export type PackageItem = {
  id: number;
  title: string;
  tooltipActive: boolean;
  tooltipDescription: string;
  iconType: IconType;
  packageType: PackageType;
  url: string | null;
};

const freePackageItems: PackageItem[] = [
  {
    id: 1,
    title: 'Logistics Explorer Web Integration',
    tooltipActive: true,
    tooltipDescription: 'Standard members get the opportunity to integrate Logistics Explorer tool branded under SeaRates into their website.',
    iconType: 'checked',
    packageType: 'free',
    url: null,
  },
  {
    id: 2,
    title: 'Listing in the members directory',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'free',
    url: null,
  },
  {
    id: 3,
    title: 'Verified Membership Certificate and Badge',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'free',
    url: null,
  },
  {
    id: 4,
    title: 'Events and Conferences',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'free',
    url: '/events',
  },
  // {
  //   id: 5,
  //   title: 'Closed Members’ Chat',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: null,
  // },
  // {
  //   id: 6,
  //   title: 'SeaRates ERP',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: '/benefits/digital-tools/searates-erp',
  // },
  // {
  //   id: 8,
  //   title: 'Rates advertisement on SeaRates.com',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: 'https://searates.com',
  // },
  // {
  //   id: 9,
  //   title: 'Vendor’s access to SeaRates open leads',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: '/benefits/shipping-leads',
  // },
  // {
  //   id: 10,
  //   title: 'Payment protection',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: '/benefits/payment-protection',
  // },
  // {
  //   id: 11,
  //   title: 'Ship Schedules Web integration: paid extra',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: null,
  // },
  // {
  //   id: 12,
  //   title: 'Container Tracking Web integration: paid extra',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: null,
  // },
  // {
  //   id: 13,
  //   title: 'Widgets customization',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: null,
  // },
  // {
  //   id: 14,
  //   title: 'Dedicated account manager',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: null,
  // },
  // {
  //   id: 15,
  //   title: 'Internal marketing',
  //   tooltipActive: false,
  //   tooltipDescription: '',
  //   iconType: 'unchecked',
  //   packageType: 'free',
  //   url: null,
  // },
];

const premiumPackageItems: PackageItem[] = [
  {
    id: 1,
    title: 'Logistics Explorer Web Integration',
    tooltipActive: true,
    tooltipDescription: 'If you join as a premium member you will get the platform integration as a white label solution for your business.',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 2,
    title: 'Listing in the members directory',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 3,
    title: 'Verified Membership Certificate and Badge',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 4,
    title: 'Events and Conferences',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: '/events',
  },
  {
    id: 5,
    title: 'Closed Members’ Chat',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 6,
    title: 'SeaRates ERP',
    tooltipActive: true,
    tooltipDescription: '5 free users included',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/digital-tools/searates-erp',
  },
  // {
  //   id: 7,
  //   title: 'CARGOES Flow by DP World',
  //   tooltipActive: true,
  //   tooltipDescription: 'The number of free unique container searches is equal to the paid membership amount.',
  //   iconType: 'checked',
  //   packageType: 'premium',
  //   url: '/benefits/digital-tools/cargoes-flow',
  // },
  {
    id: 8,
    title: 'Rates advertisement on SeaRates.com',
    tooltipActive: true,
    tooltipDescription: 'Largest tariff search engine in the world for international shipping',
    iconType: 'checked',
    packageType: 'premium',
    url: 'https://searates.com',
  },
  {
    id: 9,
    title: 'Vendor’s access to SeaRates open leads',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/shipping-leads',
  },
  {
    id: 10,
    title: 'Payment protection',
    tooltipActive: true,
    tooltipDescription: 'up to $50k coverage',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/payment-protection',
  },
  {
    id: 11,
    title: 'Ship Schedules Web integration: 600 s/m',
    tooltipActive: true,
    tooltipDescription: '600 searches per month available with a premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 12,
    title: 'Container Tracking Web integration: 100 с/m',
    tooltipActive: true,
    tooltipDescription: '100 unique containers per month available with a Premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 13,
    title: 'Widgets customization',
    tooltipActive: true,
    tooltipDescription: 'Premium members can customize our white-label Logistics Explorer, Tracking System and Ship Schedules tools for their websites!',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 14,
    title: 'Dedicated account manager',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 15,
    title: 'Internal marketing',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 16,
    title: '1 Complimentary Pass for Global Events',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 17,
    title: '10% discount for Booth during Global Events',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
];

const premiumPlusPackageItems: PackageItem[] = [
  {
    id: 1,
    title: 'Logistics Explorer Web Integration',
    tooltipActive: true,
    tooltipDescription: 'If you join as a premium member you will get the platform integration as a white label solution for your business.',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 2,
    title: 'Listing in the members directory',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 3,
    title: 'Verified Membership Certificate and Badge',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 4,
    title: 'Events and Conferences',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: '/events',
  },
  {
    id: 5,
    title: 'Closed Members’ Chat',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 6,
    title: 'SeaRates ERP',
    tooltipActive: true,
    tooltipDescription: '5 free users included',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/digital-tools/searates-erp',
  },
  {
    id: 8,
    title: 'Rates advertisement on SeaRates.com',
    tooltipActive: true,
    tooltipDescription: 'Largest tariff search engine in the world for international shipping',
    iconType: 'checked',
    packageType: 'premium',
    url: 'https://searates.com',
  },
  {
    id: 9,
    title: 'Vendor’s access to SeaRates open leads',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/shipping-leads',
  },
  {
    id: 10,
    title: 'Payment protection',
    tooltipActive: true,
    tooltipDescription: 'up to $100k coverage',
    iconType: 'checked',
    packageType: 'premium',
    url: '/benefits/payment-protection',
  },
  {
    id: 11,
    title: 'Ship Schedules Web integration: 600 s/m',
    tooltipActive: true,
    tooltipDescription: '600 searches per month available with a premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 12,
    title: 'Container Tracking Web integration: 300 с/m',
    tooltipActive: true,
    tooltipDescription: '300 unique containers per month available with a Premium subscription, all of the above are paid extra',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 13,
    title: 'Widgets customization',
    tooltipActive: true,
    tooltipDescription: 'Premium members can customize our white-label Logistics Explorer, Tracking System and Ship Schedules tools for their websites!',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 14,
    title: 'Dedicated account manager',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 15,
    title: 'Internal marketing',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 16,
    title: '2 Complimentary Pass for Global Events',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
  {
    id: 17,
    title: '15% discount for Booth during Global Events',
    tooltipActive: false,
    tooltipDescription: '',
    iconType: 'checked',
    packageType: 'premium',
    url: null,
  },
];

export { freePackageItems, premiumPackageItems, premiumPlusPackageItems };